import axios from 'axios';

const ENDPOINT =
    '/actions/mg-motors-europe-module/site-controller/get-form-token';

// One signed render token per page load, memoised in-memory and shared across
// all form components so a page with several forms fires a single
// get-form-token request. In-memory only (not sessionStorage) so it can't
// bleed across sessions. Resolves to '' on failure — a missing token is logged
// but never enforced — and the failure is not cached so the next mount retries.
let pending = null;

export const getFormRenderToken = () => {
    if (pending) return pending;

    pending = axios
        .get(ENDPOINT)
        .then((res) => res.data?.token ?? '')
        .catch(() => {
            pending = null;
            return '';
        });

    return pending;
};
